import { jsx } from "react/jsx-runtime";
import { usePromptInputAttachments } from "../../../ai-elements/prompt-input.js";
import { IconImageUpload } from "../ConciergeIcons.js";
const AttachmentButton = ({ disabled, styles, resolveColor }) => {
  const attachments = usePromptInputAttachments();
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      disabled,
      onClick: () => attachments.openFileDialog(),
      "aria-label": "Attach image",
      className: "tw:p-0 tw:bg-transparent tw:border-none tw:cursor-pointer disabled:tw:cursor-not-allowed tw:transition-colors",
      style: { width: styles.iconSize, height: styles.iconSize },
      children: /* @__PURE__ */ jsx(
        IconImageUpload,
        {
          size: styles.iconSize,
          style: {
            color: resolveColor(styles.iconColor),
            opacity: disabled ? 0.5 : 1,
            transition: "opacity 0.15s ease"
          }
        }
      )
    }
  );
};
export {
  AttachmentButton
};
//# sourceMappingURL=AttachmentButton.js.map
